export type OnCustomFieldChange = ({
  id,
  value,
  allFields,
  namespace,
}: {
  id: string;
  value: any;
  allFields: Record<string, { id: string; value: any }>;
  namespace: string;
}) => void;
